import { observer } from "mobx-react-lite";
import React, { useEffect, useState } from "react";
import controllerState from "../../service/state/controller.state";
import { Button_v1 } from "../../UI/components/Button_v1";
import apiRequest from "../../service/api/api.request";
import iconVisibleOn from "../../images/icons/on_dark_grey32.png";
import iconVisibleOff from "../../images/icons/off_dark_grey32.png";
import userState from "../../service/state/user.state";
import { toJS } from "mobx";

const ControllersStat = observer(({ setConfirm, setConfirmMsg }) => {
  const [categoryUpdateList, setCategoryUpdateList] = useState(false);
  const [categoryUpdate, setCategoryUpdate] = useState(false);
  const [categoryCreate, setCategoryCreate] = useState(false);
  const [newNameCategory, setNewNameCategory] = useState("");
  const [draggedItem, SetDraggedItem] = useState(null);
  const [notCategoryVisible, setNotCategoryVisible] = useState(true);
  // useEffect(() => {
  //   console.log("this_controller", controllerState.this_controller);
  // }, []);

  const onDragStart = (t) => {
    console.log(t);
    SetDraggedItem(t);
  };

  const onDragOver = (e) => {
    e.preventDefault();
  };

  const onDrop = async (e, category) => {
    e.preventDefault();
    if (!draggedItem || !category) {
      return;
    }
    console.log(e, category, draggedItem);
    console.log("draggedItem", toJS(draggedItem), "category", toJS(category));
    if (Array.isArray(category.data)) {
      const tagID = category.data.find((t) => t.id_tag === draggedItem.id_tag);
      if (tagID) {
        return;
      }
    }
    setConfirmMsg(
      `Вы уверены, что хотите переместить тег ${
        draggedItem.name_tag
      } в категорию ${category.name ? category.name : "без категории"}`,
    );
    controllerState.setParameters("funcTagMoveData", {
      tag: draggedItem.id_tag,
      id: category.id,
    });
    setConfirm(true);
    SetDraggedItem(null);
  };

  const createNewCategory = () => {
    setCategoryUpdateList(false);
    setCategoryCreate(false);
    apiRequest.addCategoryController(newNameCategory);
  };

  return (
    <div className="controller_stat_container">
      <div className="controller_stat_category">
        {controllerState.list_category
          .filter((vc) => vc.visible)
          .map((tag) => (
            <ul
              // onDragEnd={(e) => console.log("onDragEnd", e)}
              onDragEnter={(e) => console.log("onDragEnter", e)}
              onDrop={(e) => onDrop(e, tag)}
              onDragOver={onDragOver}
              className="controller_stat_group"
              key={tag.id}
            >
              <li
                onDrop={(e) => onDrop(e, tag)}
                className="controller_stat_group_title controller_stat_group_title_sticky"
              >
                <span>{tag.name}</span>
                <div
                  onClick={() =>
                    controllerState.updateCategoryBoolean("update", tag.id)
                  }
                  className="point_menu_container"
                >
                  <span className="point_menu"></span>
                  <span className="point_menu"></span>
                  <span className="point_menu"></span>
                </div>
              </li>
              {tag.update ? (
                <li>
                  Перетащите тэг в категорию, что бы его переместить или в поле
                  "Без категории", что бы отвязать тэг от текущей категории
                </li>
              ) : (
                <></>
              )}
              {tag.data ? (
                tag.data.map((t) => (
                  <li
                    key={t.id_tag}
                    draggable={tag.update}
                    onDragStart={() => onDragStart(t)}
                    className="controller_stat_group_item"
                  >
                    {t.tag_name}
                    <span>{t.name_tag} </span>
                    <span
                      className={
                        controllerState.nameError.some((name) =>
                          t?.parameter_value.toLowerCase().includes(name),
                        )
                          ? "error_state"
                          : ""
                      }
                    >
                      {t.parameter_value}
                    </span>
                  </li>
                ))
              ) : (
                <></>
              )}
            </ul>
          ))}
        {notCategoryVisible ? (
          <ul
            onDrop={(e) =>
              onDrop(e, {
                id: null,
                name: null,
                data: controllerState.this_controller?.not_tags ?? [],
              })
            }
            onDragOver={onDragOver}
            className="controller_stat_group"
          >
            <li className="controller_stat_group_title controller_stat_group_title_sticky">
              <span>Без категории</span>
              <div
                className="point_menu_container"
                onClick={() => setCategoryUpdate(!categoryUpdate)}
              >
                <span className="point_menu"></span>
                <span className="point_menu"></span>
                <span className="point_menu"></span>
              </div>
            </li>
            {categoryUpdate ? (
              <li className="controller_stat_group_item">
                Перетащите тэг в категорию, чтобы привязать его к категории
              </li>
            ) : (
              <></>
            )}

            {controllerState.this_controller.not_tags.map((t) => (
              <li
                key={t.id_tag}
                draggable={categoryUpdate}
                onDragStart={() => onDragStart(t)}
                className="controller_stat_group_item"
              >
                <span>{t.name_tag} </span>
                <span
                  className={
                    controllerState.nameError.some((name) =>
                      t?.parameter_value.toLowerCase().includes(name),
                    )
                      ? "error_state"
                      : ""
                  }
                >
                  {t.parameter_value}
                </span>
              </li>
            ))}
          </ul>
        ) : (
          <></>
        )}
      </div>
      <div className="controller_stat_bar">
        <ul className="controller_stat_group">
          <li className="controller_stat_group_title controller_stat_group_title_sticky">
            <span>Категории</span>
            <div
              className="point_menu_container"
              onClick={() => setCategoryUpdateList(!categoryUpdateList)}
            >
              <span className="point_menu"></span>
              <span className="point_menu"></span>
              <span className="point_menu"></span>
            </div>
          </li>
          {!categoryUpdateList && !categoryCreate ? (
            controllerState.list_category.map((c) => (
              <li
                className="controller_stat_group_item"
                style={{ color: c.visible ? "black" : "grey" }}
              >
                <span>{c.name}</span>
                <img
                  onClick={() =>
                    controllerState.updateCategoryBoolean("visible", c.id)
                  }
                  className={
                    c.visible ? "img_icon_visible_on" : "img_icon_visible_off"
                  }
                  src={c.visible ? iconVisibleOn : iconVisibleOff}
                  alt="видимость"
                />
              </li>
            ))
          ) : categoryUpdateList && !categoryCreate ? (
            <ul>
              <li className="controller_stat_group_item">
                <img
                  src="https://img.icons8.com/?size=100&id=1501&format=png&color=000000"
                  alt="Добавить"
                  className="btn_add_new_category"
                  onClick={() => setCategoryCreate(true)}
                />{" "}
                <span>добавить</span>
              </li>
            </ul>
          ) : (
            <ul className="controller_stat_group_create_container">
              <li>Введите имя категории</li>
              <li>
                <input
                  className="controller_stat_group_create_inpt"
                  type="text"
                  placeholder="Новый контроллер"
                  value={newNameCategory}
                  onChange={(e) => setNewNameCategory(e.target.value)}
                />
              </li>
              <li className="flx_bt2">
                <Button_v1 name="Создать" onClick={createNewCategory} />
                <Button_v1
                  onClick={() => setCategoryCreate(false)}
                  name="Отмена"
                />
              </li>
            </ul>
          )}
          {!categoryUpdateList && !categoryCreate ? (
            <li className="controller_stat_group_item">
              <span>Без категории</span>
              <img
                onClick={() => setNotCategoryVisible(!notCategoryVisible)}
                className={
                  notCategoryVisible
                    ? "img_icon_visible_on"
                    : "img_icon_visible_off"
                }
                src={notCategoryVisible ? iconVisibleOn : iconVisibleOff}
                alt="видимость"
              />
            </li>
          ) : (
            <></>
          )}
        </ul>
      </div>
    </div>
  );
});

export default ControllersStat;
